import { assignRefs, cx } from "@jugl-web/utils";
import React, { useEffect, useRef, useState } from "react";
import OTPInput from "react-otp-input";
import { ReactComponent as SuccessIcon } from "./assets/success.svg";
import { ReactComponent as ErrorIcon } from "./assets/error.svg";

export const WhatsappPinDialogContent: React.FC<{
  title: string;
  subtitle: string;
  pin: string;
  errorMessage?: string;
  successMessage?: string;
  onPinChange: (pin: string) => void;
}> = ({ title, subtitle, errorMessage, successMessage, pin, onPinChange }) => {
  const [focusedIndex, setFocusedIndex] = useState<number | null>(0);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 150);
  }, []);

  return (
    <div className="flex flex-col gap-12 py-8 px-10">
      <div className="flex flex-col gap-2">
        <span className="font-secondary text-2xl font-medium text-[#1A2023]">
          {title}
        </span>
        <span className="text-dark-700 font-secondary text-sm">{subtitle}</span>
      </div>
      <div className="flex flex-col gap-4">
        <OTPInput
          value={pin}
          onChange={(e) => {
            const value = e.replace(/[^0-9]/g, "");

            onPinChange(value);
          }}
          containerStyle={{
            justifyContent: "space-between",
            gap: "10px",
            width: "max-content",
          }}
          renderInput={({ ref, ...props }, index) => (
            <input
              ref={index === 0 ? assignRefs([inputRef, ref]) : ref}
              {...props}
              className={cx(
                "text-dark font-secondary select-none rounded-[10px] border border-solid border-[#D2D2D8] bg-white text-sm focus:outline-none",
                focusedIndex === index && "border-primary-200 border-[3px]"
              )}
              onBlur={() => setFocusedIndex(null)}
              onFocus={() => setFocusedIndex(index)}
            />
          )}
          inputType="tel"
          inputStyle={{
            width: "60px",
            height: "53px",
          }}
          numInputs={6}
        />
        {(errorMessage || successMessage) && (
          <div className="flex items-center gap-2">
            {errorMessage ? <ErrorIcon /> : <SuccessIcon />}
            <span
              className={cx(
                "font-secondary text-secondary-900 text-sm",
                errorMessage && "text-tertiary-900"
              )}
            >
              {errorMessage || successMessage}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
